module.exports = __webpack_public_path__ + "static/img/2-1.b83e7fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/paixu/2-1.png
// module id = P7B9
// module chunks = 5